// extracted by mini-css-extract-plugin
export default {"wrapper":"RootLayout_wrapper__yv1t+","root":"RootLayout_root__am8Ok","loader":"RootLayout_loader__UR376"};